// import ChatbotScriptContent from './chatbot-script';
import ChatBotTabs from './chatbot-tabs';

interface ChatBotProps {
	closeChatBot: () => void;
	step: boolean;
}
const CloseSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-6 h-6"
		>
			<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
		</svg>
	);
};

const TechChatBot: React.FC<ChatBotProps> = ({ closeChatBot, step }) => {
	return (
		<>
			<div className={`mainWrapBlue rounded-t-xl flex flex-col`}>
				{/* window header */}
				<div className="flex justify-between my-4 px-3">
					<h4 className="text-2xl font-medium m-0">Where is my tech</h4>
					<button
						type="button"
						onClick={closeChatBot}
						className="flex justify-center items-center rounded-full w-8 h-8"
					>
						<CloseSVG />
					</button>
				</div>
				{/* window content wrapper */}
				<div>
					<ChatBotTabs />
				</div>
			</div>
		</>
	);
};
export default TechChatBot;
